import { render } from "./HeaderCont.vue?vue&type=template&id=5807bc70"
const script = {}

import "./HeaderCont.vue?vue&type=style&index=0&id=5807bc70&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__